window.M = window.M || {};
window.M.Api = window.M.Api || {};
window.M.Api.Whitelist = {
	getWhitelists: function(onComplete) {
		return M.Api.get("/api/Whitelist", onComplete);
	},
	deleteWhitelist: function(owner, onComplete) {
		return M.Api.makeCall("DELETE", "/api/whitelist/" + encodeURIComponent(owner), null, onComplete);
	},
	checkWhitelist: function(onComplete) {
		return M.Api.get("/api/Whitelist/check", onComplete);
	},
	postWhitelist: function(owner, ip, isSpecial, onComplete) {
		return M.Api.post("/api/Whitelist", JSON.stringify({ owner: owner, ipaddress: ip, isSpecial: isSpecial }), onComplete);
	},
	postSelfWhitelist: function(onComplete) {
		return M.Api.post("/api/Whitelist/self", null, onComplete);
	}
};